import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { pascalCase } from 'change-case'
import ReactTable from 'react-table'
import { Card, CardHeader, CardContent } from '@material-ui/core'
import { ReferenceBankGuaranteeContainer } from './styled'
import { bgVendorDetailPath, bgVendorRequestDetailPath } from 'routes'
import { StatusTag } from '../../../../styled'
import { numberFormat } from 'core/utilities'

const ReferenceBankGuarantee = (props) => {
  const { valueForm = {} } = props

  useEffect(() => {
  }, [])

  const columnRef = [
    {
      Header: 'Bank Guarantee No.',
      accessor: 'bankGuaranteeNumber',
      Cell: (row) => <div className='link' onClick={() => window.open(bgVendorDetailPath(row.original.bankGuaranteeId), '_blank')}>{row.value}</div>
    }, {
      Header: 'Amount (THB)',
      accessor: 'amount',
      width: 200,
      Cell: (row) => numberFormat(row.value)
    }, {
      Header: 'Bank',
      accessor: 'bankOwner',
    }, {
      Header: 'Document Type',
      accessor: 'documentType',
      width: 100,
      style: { display: 'flex', justifyContent : 'center' },
      Cell: (row) => pascalCase(row.value)
    }
  ]

  const showRef = () => {
    return (valueForm.createType === 'extend') ||
           (valueForm.createType === 'original' && (valueForm.bgExtended || []).length > 0) ||
           (valueForm.requestType) ||
           (valueForm.newBgs || []).length > 0
  }

  return (
    showRef() ?
    <Card style={{ marginTop: '10px' }}>
      <CardHeader title={`Bank Guarantee Reference`} />
      <CardContent>
        {
          valueForm.requestType ?
            <ReferenceBankGuaranteeContainer>
              <div className='rowFields'>
                <div className='title'>Reference Request No. ({pascalCase(valueForm.requestType)}) : </div>
                <div className='value link' onClick={() => window.open(bgVendorRequestDetailPath(valueForm.requestId), '_blank')}>
                  {valueForm.requestDocumentNumber}
                </div>
              </div>
              {
                (valueForm.references || []).length > 0 ?
                  <ReactTable
                    data={valueForm.references}
                    columns={columnRef}
                    sortable={false}
                    pageSize={valueForm.references.length}
                    defaultPageSize={valueForm.references.length}
                    className='-striped -highlight'
                    style={{ marginTop: '10px' }}
                    showPagination={false}
                  /> : null
              }
            </ReferenceBankGuaranteeContainer> : null
        }
        {
          valueForm.createType === 'extend' ?
            <ReferenceBankGuaranteeContainer>
              <div className='rowFields'>
                <div className='title'>Extend BG No. :</div>
                <div className='value link' onClick={() => window.open(bgVendorDetailPath(valueForm.referenceBankGuaranteeId), '_blank')}>
                  {valueForm.referenceBankGuaranteeNumber}
                </div>
              </div>
              {
                (valueForm.newBgs || []).length > 0 ?
                  <div className='rowFields' style={{ flexDirection: 'column' }}>
                    <div className='title'>Reference New BG :</div>
                    <ul style={{ marginTop: '5px', marginBottom: '0px', paddingLeft: '30px' }}>
                    {
                      valueForm.newBgs.map((data, index) =>
                        <li>
                          <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <div className='value link' onClick={() => window.open(bgVendorDetailPath(data.id), '_blank')}>
                              {data.bankGuaranteeNumber}
                            </div>
                            <StatusTag status={data.status} style={{ marginLeft: '10px' }}>{data.statusName}</StatusTag>
                          </div>
                        </li>
                      )
                    }
                    </ul>
                  </div> : null
              }
            </ReferenceBankGuaranteeContainer> : null
        }
        {
          valueForm.createType === 'original' && 
          [...(valueForm.bgExtended || []), ...(valueForm.newBgs || [])].length > 0 ?
            <ReferenceBankGuaranteeContainer>
              <div className='rowFields' style={{ flexDirection: 'column' }}>
                <div className='title'>Reference New BG :</div>
                <ul style={{ marginTop: '5px', marginBottom: '0px', paddingLeft: '30px' }}>
                {
                  [...(valueForm.bgExtended || []), ...(valueForm.newBgs || [])].map((data, index) =>
                    <li>
                      <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <div className='value link' onClick={() => window.open(bgVendorDetailPath(data.id), '_blank')}>
                          {data.bankGuaranteeNumber}
                        </div>
                        <StatusTag status={data.status} style={{ marginLeft: '10px' }}>{data.statusName}</StatusTag>
                      </div>
                    </li>
                  )
                }
                </ul>
              </div>
            </ReferenceBankGuaranteeContainer> : null
        }
      </CardContent>
    </Card> : null
  )
}

const mapStateToProps = (state) => {
  return ({
  })
}

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(ReferenceBankGuarantee)